module.exports = __webpack_public_path__ + "img/hipercard.f0c6b1f1.png";